<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        
            <div class="row row-replace">
                <div class="col-md-8 col-pn border">
                    <div>
                        <nav class="bg-primary text-white">
                            <div class="nav nav-tabs bg-blue">
                              <a class="nav-item d-heading h4">Welcome</a>
                              <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#dashboard-quicklink" role="tab" aria-selected="true"><i class="fa fa-paperclip"></i> QuickLink</a>
                              <a class="nav-item nav-link" id="nav-profile-tab" data-toggle="tab" href="#dashboard-approval" role="tab" aria-selected="false"><i class="fa fa-check-circle-o"></i> Approval</a>
                              <a class="nav-item flex"></a>
                              <a class="nav-item cus-search-nav p-r-10"><input type="text" placeholder="search" class="form-control cus-search"></a>
                            </div>
                          </nav>
                          <div class="tab-content" id="nav-tabContent">
                            <div class="tab-pane fade show active" id="dashboard-quicklink" role="tabpanel">
                              <div class="row row-replace">
                                <div class="col-md-4 h5"><i class="fa fa-list"></i> All by Category</div>
                                <div class="col-md-8">
                                  <marquee class="text-danger"> <i class="fa fa-exclamation-triangle"></i> Warning! message scroll right to left change password after 3 month</marquee>
                                </div>
                              </div>  
                              
                              
                              <section class="shadow1 border-rad d-mlr">
                                  <div class="bg-primary text-white d-pad border-rad">Attendance App</div>
                                  <div class="bg-white d-qui-hed row text-center">
                                      <a href="#" class="col-4 col-md-2 p-10">
                                        <img src="assets/new_icon/attandence.png" width="40">
                                        <h5 class="m-0">Leaves</h5>
                                      </a>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="40">
                                        <h5 class="m-0">Attendance Regularization</h5>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="40">
                                        <h5 class="m-0">Compliance</h5>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="40">
                                        <h5 class="m-0">COVID19 Helpline</h5>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="40">
                                        <h5 class="m-0">Employee Assistance</h5>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="40">
                                        <h5 class="m-0">Employee Clearance</h5>
                                      </div>
                                  </div>
                                </section>

                                <section class="shadow1 border-rad m-t-10 d-mlr">
                                  <div class="bg-primary text-white d-pad border-rad">Attendance App</div>
                                  <div class="bg-white d-qui-hed row text-center">
                                      <div class="col-4 col-md-2 p-10">
                                        <a href="#" class="block">
                                          <img src="assets/new_icon/attandence.png" width="40">
                                          <h4 class="m-0">Leave</h4>
                                          </a>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="30">
                                        <h3 class="m-0">Leave</h3>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="30">
                                        <h3 class="m-0">Leave</h3>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="30">
                                        <h3 class="m-0">Leave</h3>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="30">
                                        <h3 class="m-0">Leave</h3>
                                      </div>
                                      <div class="col-md-2 col-4 p-10">
                                        <img src="assets/new_icon/attandence.png" width="30">
                                        <h3 class="m-0">Leave</h3>
                                      </div>
                                  </div>
                                </section>


                            </div>
                            <div class="tab-pane fade" id="dashboard-approval" role="tabpanel">...</div>
                           
                          </div>
                    </div>    
                </div>

                <div class="col-md-4">
                    
                  <div class="border bg-white shadow">
                    <div class="bg-primary text-white d-pad">
                       Employee Details
                    </div>
                    <table class="table m-b-0">
                       <tr>
                          <td>Employee id</td>
                          <td>Admin</td>
                       </tr>
                       <tr>
                          <td>Name</td>
                          <td>Admin</td>
                       </tr>
                       <tr>
                          <td>Reporting Manager</td>
                          <td>Admin</td>
                       </tr>
                       <tr>
                          <td>Designation</td>
                          <td>Admin</td>
                       </tr>
                       <tr>
                          <td>Department</td>
                          <td>Admin</td>
                       </tr>
                       <tr>
                          <td>Site Name</td>
                          <td>Admin</td>
                       </tr>
                    </table>
                 </div>
        <!--second row-->
                    <div class="border bg-white shadow mt-3">
                      <!-- <div class="bg-primary text-white d-pad">Employee Details</div> -->
                      <nav class="bg-primary text-white">
                        <div class="nav nav-tabs bg-blue">
                          <a class="nav-item nav-link active" id="birthday" data-toggle="tab" href="#birthday-tab" role="tab" aria-selected="true"><i class="fa fa-birthday-cake"></i> Today Birthday</a>
                          <a class="nav-item nav-link" id="workani" data-toggle="tab" href="#workani-tab" role="tab" aria-selected="false"><i class="fa fa-plus-circle"></i> Work Anniversary</a>
                        </div>
                      </nav>
                      <div class="tab-content">
                        <div class="tab-pane fade show active" id="birthday-tab" role="tabpanel">

                          <ul>
                            <li>
                              <span><i class="fa fa-user"></i></span>
                              <span>name and text</span>
                              <span>wish area</span>
                            </li>
                          </ul>

                        </div>
                        <div class="tab-pane fade" id="workani-tab" role="tabpanel">work ani</div>
                        </div>
                  </div>

        <!--third row-->
                  <div class="border bg-white shadow mt-3">
                    <div class="bg-primary text-white d-pad">
                       Leave Balance
                    </div>
                    <div class="row row-replace mt-1">
                      <div class="col-6 col-p">
                        <div class="c-card border border-info shadow">
                          <header class="bg-secondary text-white p-1">Casual Leave</header>
                          <main class="d-cbody form-inline p-1">
                            <aside>CL</aside>
                            <div>
                              <h5>Casul Leave <span>20</span></h5>
                            </div>
                          </main>
                        </div>
                      </div>
                      <div class="col-6 col-p">
                        <div class="c-card border border-info shadow">
                          <header class="bg-secondary text-white p-1">Privilege Leave</header>
                          <main class="d-cbody form-inline p-1">
                            <aside>PL</aside>
                            <div>
                              <h5>Privilege Leave <span>20</span></h5>
                            </div>
                          </main>
                        </div>
                      </div>
                    </div>
                    <div class="row row-replace mt-1">
                      <div class="col-6 col-p">
                        <div class="c-card border border-info shadow">
                          <header class="bg-secondary text-white p-1">Sick Leave</header>
                          <main class="d-cbody form-inline p-1">
                            <aside>SL</aside>
                            <div>
                              <h5>Sick Leave <span>20</span></h5>
                            </div>
                          </main>
                        </div>
                      </div>
                      <div class="col-6 col-p">
                        <div class="c-card border border-info shadow">
                          <header class="bg-secondary text-white p-1">SL/CL Leave</header>
                          <main class="d-cbody form-inline p-1">
                            <aside>SL/CL</aside>
                            <div>
                              <h5>Leave <span>20</span></h5>
                            </div>
                          </main>
                        </div>
                      </div>
                    </div>
                 </div>
        <!--fourth row-->
                 <div class="border bg-white shadow mt-3">
                  <div class="bg-primary text-white d-pad">
                     New Opportunity
                  </div>
                  
               </div>



                </div>
            </div>

           
             
             

      <!--end page body contant -->
      
    </div>
</div>
<!-- /Page Wrapper -->           

